import styled from 'styled-components';
import { Icon } from '../../Icon';

export const ErrorIcon = styled(Icon)`
    color: ${({ theme }) => theme.designTokens.TEXT_ALERT_DANGER};
    align-self: center;
`;
